<template>
  <div class="AF-city-tag" @mouseleave="hidePopover" @mouseenter="showPopover">
    <div class="AF-city-name" :class="{ hover: provinceShow }">
      {{ area.name }}
      <i
        :class="[provinceShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"
      ></i>
    </div>
    <div class="AF-district" v-if="provinceShow" :style="{ transform: transformWidth }">
      <div class="AF-district-title">{{ `${province}-${area.name}` }}</div>
      <div class="AF-district-main">
        <el-checkbox
          :indeterminate="count(area)"
          v-model="area.checkall"
          @change="cheackall($event, area)"
        >
          全部区县
        </el-checkbox>
        <el-checkbox-group v-model="checkedCities" @change="formarea = area">
          <!-- 全部区县 -->
          <el-checkbox
            v-for="city in area.children"
            :label="city"
            :key="city.no"
            @change="city.checked = !city.checked"
          >
            {{ city.name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="AF-district-btn">
        <el-button class="button-cancle" size="small" @click="cancel">
          取消
        </el-button>
        <el-button
          class="button-ok"
          type="primary"
          size="small"
          @click="
            checkedCitiesbf = [...checkedCities]
            area.t = false
            formarea = area
            submitArea()
          "
        >
          确认
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    area: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Array,
      default: () => {
        return []
      }
    },
    province: {
      type: String,
      default: "全国"
    }
  },
  computed: {
    // 保持展示区域框居中
    transformWidth({ area }) {
      const { name = "" } = area
      let a = 40 + name.length * 14
      return `translate(calc(-50% + ${a / 2}px), -10px)`
    }
  },
  data() {
    return {
      provinceShow: false,
      //当前选中区
      checkedCities: [],
      checkedCitiesbf: [],
      //当前选中市区
      formarea: {}
    }
  },
  methods: {
    cancel() {
      this.checkedCities = [...this.checkedCitiesbf]
      this.provinceShow = false
    },
    // 地区确认
    submitArea() {
      let areaId = []
      if (this.checkedCities) {
        if (this.formarea.checkall) {
          areaId.push({
            name: this.formarea.name,
            no: this.checkedCities.map(i => i.no)
          })
        } else {
          this.checkedCities.forEach(item => {
            areaId.push({
              no: item.no,
              name: item.name,
              hide: item.parentNo == this.formarea.no && this.formarea.checkall
            })
          })
        }
        this.$parent.$parent.$refs.screen.locationAddresscode.cityId = this.formarea.no
        this.$parent.$parent.$refs.screen.locationAddresscode.cityName = this.formarea.name
        this.$parent.$parent.$refs.screen.locationAddresscode.isAll =this.formarea.checkall
        this.$parent.$parent.$refs.screen.locationAddress = areaId
        this.provinceShow = false
      }
    },
    //计算当前市区半选和全选状态
    count(item) {
      let arr = item.children
      if (!arr) return false
      let checkarr = this.checkedCities.filter(v => v.parentNo == item.no)
      if (checkarr.length == arr.length) {
        item.checkall = true
        this.formarea = item
      } else item.checkall = false
      return checkarr.length > 0 && checkarr.length < arr.length
    },
    //全选
    cheackall(type, area) {
      let arr = this.checkedCities.filter(v => v.parentNo != area.no)
      if (type) this.checkedCities = arr.concat(area.children)
      else this.checkedCities = arr
    },
    showPopover() {
      this.provinceShow = true
      this.checkedCities = []
      this.formarea = []
    },
    hidePopover() {
      this.provinceShow = false
    }
  }
}
</script>  

<style lang="scss" scoped>
.AF-city-tag {
  /deep/.AF-city-name {
    position: relative;
    padding: 0 12px;
    display: inline-block;
    height: 30px;
    line-height: 24px;
    border: 1px solid #fff;
    border-radius: 4px 4px 0px 0px;
    color: #333;
    &.hover {
      z-index: 300;
      border-top-color: #e4e7ed;
      border-left-color: #e4e7ed;
      border-right-color: #e4e7ed;
      border-bottom-color: #fff;
      color: #b79255;
    }
    .el-icon-caret-bottom{
      color: #969696;
    }
  }
  .AF-district {
    width: 400px;
    z-index: 200;
    background: #fff;
    position: absolute;
    transform: translate(calc(-50% + 34px), -5px) !important;
    border: 1px solid #e4e7ed;
    .AF-district-title {
      line-height: 40px;
      text-indent: 20px;
      border-bottom: 1px dashed #e4e7ed;
    }
    .AF-district-main {
      padding: 10px 20px;
      line-height: 30px;
    }
    .AF-district-btn {
      border-top: 1px dashed #e4e7ed;
      padding: 8px;
      line-height: 32px;
      text-align: center;
      .button-cancle{
        color:#333;
        border-color: #E4E7ED;
        background: #F5F7FA;
        &:hover{
          background: #F5F7FA;
          color: #333;
          border-color: #E4E7ED;
        }
      }
      .button-ok{
        background: #B79255;
        border-color: #B79255;
      }
    }
  }
}
</style>